(function (w, $) {
    var primaryColor = "#0689d1";

    w.beAlert = function (message, type, extraParams) {
        var params = {
            text: message,
            confirmButtonColor: primaryColor
        };

        if (type) {
            params.type = type;
        }

        if (extraParams) {
            params = $.extend(
                params,
                extraParams
            );
        }

        return swal(params);
    };

    w.beConfirm = function (message, extraParams) {
        var params = {
            title: "Weet je het zeker?",
            text: message,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: primaryColor,
            cancelButtonText: "Annuleren",
            confirmButtonText: "Ja"
        };

        if (extraParams) {
            params = $.extend(
                params,
                extraParams
            );
        }

        return swal(params);
    };
})(window, jQuery);
